import fetch from './handler'

export const getCognitoToken = (params) => {
    return fetch({
        method: 'GET',
        url: '/cognito/token',
        params
    })
}